"use client";

import React, { useState, useEffect } from "react";
import { fetchUserAttributes } from "aws-amplify/auth";
import {
  DeleteNeighborhoodImage,
  UpdateNeighborhoodImage,
  UpdateNeighborhoodrate,
  helpnhimagesreview,
  updatenhsummaryimage,
} from "../../../modules/Graphql/neighborhoodimagegraphql.js";
import { NhGallery } from "../../../components/index.js";
import GalleryPopup from "./GalleryPopup";
import EditCaptionModal from "./EditCaptionModal";
import { customStylesSlide } from "./modalStyles";
import { imageData } from "./data.json";

export default function NeighborhoodGallery({
  neighborhoodId,
  nhdetails,
  initialImages = [],
  isMobile = false,
}) {
  const [userId, setUserId] = useState("");
  const [isEditor, setIsEditor] = useState(false);
  const [nhimagesdata, setNhimagesdata] = useState(
    initialImages.length > 0 ? initialImages : imageData,
  );
  const [selectedItem, setSelectedItem] = useState(0);
  const [modalSlider, setModalSlider] = useState(false);
  const [editcaptionmodal, setEditcaptionmodal] = useState(false);
  const [selectedcaption, setSelectedcaption] = useState("");
  const [selectedcaptionID, setSelectedcaptionID] = useState("");
  const [islistingmodalopen, setIslistingmodalopen] = useState(false);
  const [popupheight, setPopupheight] = useState(0);
  const [is_slider, setIs_slider] = useState(false);
  const [is_static, setIs_static] = useState(initialImages.length === 0);
  const [loaderactive, setLoaderactive] = useState(false);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        const attributes = await fetchUserAttributes();

        // Get user ID from localStorage
        const storedUserId = localStorage.getItem("userId");
        if (storedUserId) {
          setUserId(storedUserId);
        }

        // Check if user is an editor
        if (attributes["custom:usertype"] === "editor") {
          setIsEditor(true);
        }
      } catch (error) {
        setUserId("");
        setIsEditor(false);
      }
    };

    checkUserStatus();
  }, []);

  useEffect(() => {
    if (initialImages && initialImages.length > 0) {
      setNhimagesdata(initialImages);
      setIs_static(false);
    } else {
      setNhimagesdata(imageData);
      setIs_static(true);
    }
  }, [initialImages]);

  const handleOpenPopup = (index, length) => {
    setModalSlider(true);
    setSelectedItem(index);

    setTimeout(() => {
      setIslistingmodalopen(true);

      // Calculate modal height for positioning
      const modalbox = document.querySelector(".ReactModal__Content");
      if (modalbox !== null) {
        const heightpx = modalbox.offsetHeight;
        setPopupheight(heightpx);
      }
    }, 500);
  };

  const handleCloseModal = () => {
    setModalSlider(false);
    setIslistingmodalopen(false);
  };

  const handleRemovePhoto = async (e, id) => {
    setIs_slider(false);

    try {
      const deletedataId = { id: id };
      await DeleteNeighborhoodImage(deletedataId);

      // Update local state by removing the deleted image
      const updatedImages = nhimagesdata.filter((img) => img.id !== id);

      if (updatedImages.length <= 0) {
        setNhimagesdata(imageData);
        setIs_static(true);
      } else {
        setNhimagesdata(updatedImages);
      }

      // Update image summary
      await updateImageSummary();

      setIs_slider(true);
    } catch (error) {
      console.error("Error deleting photo:", error);
      setIs_slider(true);
    }
  };

  const handleEditPhotoCaption = (e, id, caption) => {
    setEditcaptionmodal(true);
    setSelectedcaption(caption);
    setSelectedcaptionID(id);
  };

  const handleCloseEditCaptionModal = () => {
    setEditcaptionmodal(false);
  };

  const handleEditCaptionSubmit = async (e) => {
    e.preventDefault();
    const caption_data = e.target.caption_summary.value;

    setIs_slider(false);

    try {
      const updatedata = {
        caption: caption_data,
        id: selectedcaptionID,
      };

      await UpdateNeighborhoodImage(updatedata);

      // Update local state with new caption
      const updatedImages = nhimagesdata.map((img) =>
        img.id === selectedcaptionID ? { ...img, caption: caption_data } : img,
      );
      setNhimagesdata(updatedImages);

      setEditcaptionmodal(false);
      setIs_slider(true);
    } catch (error) {
      console.error("Error updating caption:", error);
      setIs_slider(true);
    }
  };

  const handleRateModal = async (imageid, e) => {
    setIs_slider(false);

    try {
      const updatedata = {
        rate: e.target.textContent,
        id: imageid,
      };

      await UpdateNeighborhoodrate(updatedata);
      await updateImageSummary();

      setIs_slider(true);
    } catch (error) {
      console.error("Error rating photo:", error);
      setIs_slider(true);
    }
  };

  const handleModalHelpful = async (e, imageid, image) => {
    const imageIndex = nhimagesdata?.findIndex((img) => img.id === imageid);
    if (imageIndex === -1) return;

    const updatedImages = [...nhimagesdata];
    const currentImage = updatedImages[imageIndex];

    if (currentImage.helpedUserId === 1) {
      currentImage.imagehelpfulcount =
        (currentImage.imagehelpfulcount || 0) - 1;
      currentImage.helpedUserId = 0;
    } else {
      currentImage.imagehelpfulcount =
        (currentImage.imagehelpfulcount || 0) + 1;
      currentImage.helpedUserId = 1;
    }

    setNhimagesdata(updatedImages);
    setLoaderactive(false);

    try {
      const adddata = {
        reviewId: imageid,
        neighborhoodId: image.neighborhoodId,
        userId: userId,
        helpStatus: 1,
        helpedDate: new Date(),
        updatedDate: new Date(),
      };

      await helpnhimagesreview(adddata);
      await updateImageSummary();

      setIs_slider(true);
    } catch (error) {
      console.error("Error marking photo as helpful:", error);
      // Revert state on error
      if (currentImage.helpedUserId === 1) {
        currentImage.imagehelpfulcount =
          (currentImage.imagehelpfulcount || 0) - 1;
        currentImage.helpedUserId = 0;
      } else {
        currentImage.imagehelpfulcount =
          (currentImage.imagehelpfulcount || 0) + 1;
        currentImage.helpedUserId = 1;
      }
      setNhimagesdata([...updatedImages]);
    }
  };

  const updateImageSummary = async () => {
    try {
      const updatedata = {
        nhid: neighborhoodId,
      };
      await updatenhsummaryimage(updatedata);
    } catch (error) {
      console.error("Error updating image summary:", error);
    }
  };

  // Don't render if no images
  if (nhimagesdata.length === 0) {
    return null;
  }

  return (
    <>
      {nhimagesdata.length > 0 && (
        <div className="nh_gallery_sec">
          <NhGallery
            imageData={nhimagesdata}
            openpopup={handleOpenPopup}
            nhid={neighborhoodId}
          />
        </div>
      )}

      {modalSlider && (
        <GalleryPopup
          modalSlider={modalSlider}
          closeModalslider={handleCloseModal}
          customStylesSlide={customStylesSlide}
          nhimagesdata={nhimagesdata}
          openpopup={handleOpenPopup}
          selectedItem={selectedItem}
          userId={userId}
          is_editor={isEditor}
          removephoto={handleRemovePhoto}
          editphotocaption={handleEditPhotoCaption}
          onRatemodal={handleRateModal}
          modalhelpful={handleModalHelpful}
          is_static={is_static}
          loaderactive={loaderactive}
          islistingmodalopen={islistingmodalopen}
          popupheight={popupheight}
          neighbor_id={neighborhoodId}
        />
      )}

      {editcaptionmodal && (
        <EditCaptionModal
          editcaptionmodal={editcaptionmodal}
          closeeditcaptionmodal={handleCloseEditCaptionModal}
          customStyles={customStylesSlide}
          EditcaptionFormSubmit={handleEditCaptionSubmit}
          selectedcaption={selectedcaption}
        />
      )}
    </>
  );
}
